function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9768 1.7458H35.7181C37.5313 1.7458 39 3.21445 39 5.0277V18.7674C39 19.6387 38.6537 20.474 38.0384 21.0909L20.1521 38.974C18.8705 40.2556 16.793 40.2556 15.5114 38.974L1.77015 25.2327C0.488565 23.9495 0.488565 21.872 1.77015 20.5905L19.6565 2.7074C20.2718 2.09204 21.1071 1.7458 21.9768 1.7458Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.8
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.2238 0H19.6811C18.9506 0 18.249 0.290841 17.7321 0.80774L2.70754 15.8295C1.63101 16.906 1.63101 18.6511 2.70754 19.729L14.2502 31.2717C15.3268 32.3482 17.0718 32.3482 18.1483 31.2717L33.1729 16.2499C33.6898 15.7316 33.9806 15.03 33.9806 14.2981V2.75679C33.9806 1.23366 32.7469 0 31.2238 0ZM26.3994 9.64878C25.2581 9.64878 24.3318 8.72249 24.3318 7.58118C24.3318 6.43987 25.2581 5.51359 26.3994 5.51359C27.5407 5.51359 28.467 6.43987 28.467 7.58118C28.467 8.72249 27.5407 9.64878 26.3994 9.64878Z",
  fill: "#055445",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 24.3773,
  y1: 1.7458,
  x2: 6.04636,
  y2: 34.4796,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF8031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8031",
  stopOpacity: 0
})));

function SvgTagVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagVector);
export default __webpack_public_path__ + "static/media/tagVector.6562fc58dbe038208d4e2b6c5f349831.svg";
export { ForwardRef as ReactComponent };